var _desc, _linearGradient, _linearGradient2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 100 100",
    height: 100,
    viewBox: "0 0 100 100",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Checkmark Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A checkmark icon indicating correct or successful actions.")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 84.9479,
    x2: 16.6742,
    y1: 10.3013,
    y2: 80.9544
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8abf47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f742e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 81.0112,
    x2: 19.0911,
    y1: 12.3011,
    y2: 78.5867
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7f088"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74a73a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.4 100c-3 0-5.9-1.3-8-3.7l-23.3-26.2c-4.1-4.8-4.1-12.4 0-17.1 4.2-4.8 11.7-4.8 15.9 0l15.4 17.3 46.5-52.3c4.2-4.7 11.7-4.7 15.9 0s4.2 12.4 0 17.1l-54.4 61.2c-2.1 2.4-4.9 3.7-8 3.7zm-23.3-46c-1.6 0-3.2.7-4.4 2.1-2.6 3-2.6 7.8 0 10.8l23.3 26.3c2.4 2.7 6.4 2.7 8.8 0l54.5-61.3c2.6-3 2.6-7.8 0-10.8-2.4-2.7-6.4-2.7-8.8 0l-48.3 54.3c-.9 1-2.7 1-3.6 0l-17.1-19.3c-1.2-1.3-2.7-2.1-4.4-2.1z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.1 54c-1.6 0-3.2.7-4.4 2.1-2.6 3-2.6 7.8 0 10.8l23.3 26.3c2.4 2.7 6.4 2.7 8.8 0l54.5-61.3c2.6-3 2.6-7.8 0-10.8-2.4-2.7-6.4-2.7-8.8 0l-48.3 54.3c-.9 1-2.7 1-3.6 0l-17.1-19.3c-1.2-1.3-2.7-2.1-4.4-2.1z",
    fill: "url(#b)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.fb80eca076a2082ca0e9a9cab5cc3c3b.svg";
export { ForwardRef as ReactComponent };